/**
 * Offline delivery queue for salesman.
 * Stores pending deliver actions in localStorage, replays when network comes back.
 */
import api from "@/api";

const KEY = "gt_offline_queue_v1";

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};
const write = (q) => localStorage.setItem(KEY, JSON.stringify(q));

export const queueDelivery = (orderId, payload) => {
  const q = read();
  q.push({ id: `${Date.now()}-${Math.random()}`, orderId, payload, queued_at: new Date().toISOString() });
  write(q);
};

export const queueSize = () => read().length;

export const getQueue = () => read();

export const clearQueueItem = (id) => {
  write(read().filter(x => x.id !== id));
};

export const flushQueue = async () => {
  const q = read();
  if (!q.length) return { synced: 0, failed: 0 };
  let synced = 0, failed = 0;
  for (const item of q) {
    try {
      await api.post(`/orders/${item.orderId}/deliver`, item.payload);
      clearQueueItem(item.id);
      synced++;
    } catch (e) {
      // Keep in queue if server is still unreachable; drop on 4xx (already delivered etc.)
      if (e?.response && e.response.status >= 400 && e.response.status < 500) {
        clearQueueItem(item.id);
        failed++;
      } else {
        failed++;
        break; // network still down, stop
      }
    }
  }
  return { synced, failed };
};

let listenersAttached = false;
let onChangeCb = null;

export const initOfflineSync = (onChange) => {
  onChangeCb = onChange;
  if (listenersAttached) return;
  listenersAttached = true;
  const tryFlush = async () => {
    const r = await flushQueue();
    if (onChangeCb) onChangeCb(queueSize(), r);
  };
  window.addEventListener("online", tryFlush);
  // Try once on load if online
  if (navigator.onLine) setTimeout(tryFlush, 1500);
};
